import qs from 'qs';
import request from '../index';
/*
 * 和售后管理有关的接口
*/

/**
* AfterSale
* @params {number} data.id
* @params {string} data.jobTitle 职称
* @params {string} data.password
* @params {string} data.phone
* @params {number} data.pid
* @params {string} data.username
*/

/**
* 售后登录
*/
export const aSlogin = (data) => request.post('/api-eye/afterSale/ASlogin', qs.stringify(data));

/**
* 删除
* @params {array} ids
*/
export const deleteAfterSale = (data) => request.delete('/api-eye/afterSale/deleteAfterSale', { data });

/**
* 获得售后人员列表
* @params {number} params.lineNum 每页显示多少条
* @params {string} params.name 名称
* @params {number} params.pageNum 页码
*/
export const getAfterSaleList = (params) => request.get('/api-eye/afterSale/getAfterSaleList', { params });

/**
* 添加售后人员
* @params {AfterSale} afterSale
*/
export const insertAfterSale = (data) => request.post('/api-eye/afterSale/insertAfterSale', data);

/**
* 更新售后人员
* @params {AfterSale} afterSale
*/
export const updateAfterSale = (data) => request.put('/api-eye/afterSale/updateAfterSale', data);

/**
* 修改密码
*/
export const updateAfterSalePassword = (data) => request.put('/api-eye/afterSale/updateAfterSalePassword', data);

/** 和售后管理有关的接口 **/

/** 
* AfterSaleRepair
* @params {string} data.analysisDept 分析部门
* @params {string} data.closedLoopMeasures 闭环措施
* @params {string} data.confirmationAndAnalysis 情况确认和分析
* @params {number} data.createUserId 
* @params {string} data.executionDept 执行部门
* @params {string} data.feedbackDate 反馈日期
* @params {string} data.feedbackDept 反馈部门
* @params {number} data.id 
* @params {string} data.implementationMeasures 执行措施
* @params {string} data.notes 备注
* @params {string} data.picture 图片
* @params {string} data.problemPhenomenon 问题现象
* @params {string} data.problemType 问题类型
* @params {string} data.produceDate 生产日期
* @params {string} data.rootCauseAnalysis 根本原因分析
* @params {string} data.serial 机身号
* @params {string} data.serialType 机身号类型
* @params {string} data.status 状态:现场维修/设备返厂/问题分析/已完成
* @params {string} data.supervisionDept 监督部门
* @params {string} data.temporaryMeasures 临时措施
* @params {string} data.video 视频
* @params {string} data.year 年度
*/

/** 
* 删除日常报修
* @params {array} ids
*/
export const deleteAfterSaleRepair = (data) => request.delete('/api-qc/deleteAfterSaleRepair', { data });

/** 
* 获取日常报修列表
* @params {string} params.endDate 结束日期
* @params {number} params.lineNum 每页显示多少条
* @params {number} params.pageNum 页码
* @params {string} params.problemType 问题类型
* @params {string} params.produceEndTime 生产结束时间
* @params {string} params.produceStartTime 生产开始时间
* @params {string} params.serial 机身号
* @params {string} params.serialType 机身号类型
* @params {string} params.startDate 开始日期
* @params {string} params.status 状态
*/
export const getAfterSaleRepairList = (params) => request.get('/api-qc/getAfterSaleRepairList', { params });

/** 
* 日常报修统计
* @params {string} params.year 年度
*/
export const getAfterSaleRepairSummary = (params) => request.get('/api-qc/getAfterSaleRepairSummary', { params });

/** 
* 添加日常报修信息
* @params {AfterSaleRepair} afterSaleRepair
*/
export const insertAfterSaleRepair = (data) => request.post('/api-qc/insertAfterSaleRepair', data);

/** 
* 修改日常报修信息
* @params {AfterSaleRepair} afterSaleRepair
*/
export const updateAfterSaleRepair = (data) => request.put('/api-qc/updateAfterSaleRepair', data);

/** 
* 导出日常报修
* @params {array} params.ids ids
*/
export const exportAfterSaleRepair = (params) => request.get(`/api-qc/exportAfterSaleRepair?${params}`, {
    responseType: 'blob'
});

/** 
* 删除根本原因分析模板
* @params {array} ids
*/
export const deleteRootCauseAnalysisTemplate = (data) => request.delete('/api-qc/deleteRootCauseAnalysisTemplate', { data });

/** 
* 获取根本原因分析模板列表
*/
export const getRootCauseAnalysisTemplateList = (params) => request.get('/api-qc/getRootCauseAnalysisTemplateList', { params });

/** 
* 新增or修改根本原因分析模板
* @params {RootCauseAnalysisTemplate} rootCauseAnalysisTemplate
*/
export const saveRootCauseAnalysisTemplate = (data) => request.put('/api-qc/saveRootCauseAnalysisTemplate', data);

/** 
* 根本原因分析统计
* @params {string} params.year 年度
*/
export const getRootCauseAnalysisSummary = (params) => request.get('/api-qc/getRootCauseAnalysisSummary', { params });

/** 
* 上传产品使用视频资料
*/
export const uploadProductVideo = (data, processFn) => request.post('/api-qc/uploadProductVideo', data, {
    onUploadProgress: processFn,
    timeout: 1800000,
});

/** 
* 添加or更新产品使用视频
* @params {ProductVideo} productVideo
*/
export const saveProductVideo = (data) => request.post('/api-qc/saveProductVideo', data);

/** 
* 获取产品使用视频列表
* @params {string} params.productType 产品类型
*/
export const getProductVideoList = (params) => request.get('/api-qc/getProductVideoList', { params });

/** 
* 删除产品使用视频
* @params {array} ids
*/
export const deleteProductVideo = (data) => request.delete('/api-qc/deleteProductVideo', { data });
